module.exports = require('../dist/compat/array/sortBy.js').sortBy;
